import { render, staticRenderFns } from "./ProducaoAcomodacao.vue?vue&type=template&id=3fd0066a"
import script from "./ProducaoAcomodacao.vue?vue&type=script&lang=ts"
export * from "./ProducaoAcomodacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports